import { Box } from '@wishket/design-system';

import { Skeleton } from '@/shared/Components';

const HeadLineListSkeleton = () => {
  return (
    <Box className="flex w-full gap-5 self-start overflow-hidden tablet:gap-6">
      {[0, 1, 2].map((_, index) => (
        <Skeleton key={index} className="h-[180px] min-w-[180px] " />
      ))}
    </Box>
  );
};

export default HeadLineListSkeleton;
